import script from "./VButtonDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./VButtonDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./VButtonDropdown.vue?vue&type=style&index=0&id=923d6d6c&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-923d6d6c"]])

export default __exports__